import { Spinner } from '@99designs/common/components';
import Button from 'common/components/Button';
import { Field } from 'common/components/Form';
import { login } from 'launch/common/xhr/accounts';
import Link from 'launch/components/Link';
import PrivacyLink from 'launch/components/PrivacyLink';
import TermsLink from 'launch/components/TermsLink';
import * as React from 'react';
import { InjectedIntl, intlShape } from 'react-intl';

interface AuthLoginFormProps {
    title: React.ReactNode;
    onSuccess: () => void;
    email: string;
}

interface AuthLoginFormState {
    errors: { [key: string]: string };
    email: string;
    password: string;
    busy: boolean;
}

class AuthLoginForm extends React.Component<AuthLoginFormProps, AuthLoginFormState> {
    public context: {
        intl: InjectedIntl;
    };

    static contextTypes = {
        intl: intlShape.isRequired,
    };

    constructor(props: AuthLoginFormProps) {
        super(props);
        this.state = {
            errors: {},
            password: '',
            email: '',
            busy: false,
        };
    }

    email: HTMLInputElement | null;
    componentDidMount() {
        if (this.email) {
            this.email.focus();
        }
    }

    attachTo = <T extends keyof AuthLoginFormState>(name: T) => {
        return {
            value: this.state[name],
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                this.setState({
                    ...this.state,
                    [name]: e.target.value,
                });
            },
        };
    };

    render() {
        const { title } = this.props;
        const t = (id: string) => this.context.intl.formatMessage({ id });

        return (
            <form onSubmit={this.handleOnSubmit} className="modal-form modal-form--wide">
                <div className="modal-form__title">{title}</div>
                <div className="modal-form__input">
                    <Field errorMessage={this.state.errors.email}>
                        <input
                            name="email"
                            placeholder={t('auth_modal.email')}
                            ref={input => (this.email = input)}
                            className="input-text"
                            {...this.attachTo('email')}
                            required
                        />
                    </Field>

                    <Field
                        errorMessage={this.state.errors.password}
                        className="field--last"
                        message={
                            <Link href="/accounts/resetpassword" variations={['default']}>
                                {t('auth_modal.forgot_password')}
                            </Link>
                        }
                    >
                        <input
                            name="password"
                            type="password"
                            placeholder={t('auth_modal.password')}
                            className="input-text"
                            {...this.attachTo('password')}
                        />
                    </Field>
                </div>

                <div className="modal-form__submit">
                    <Button typeAttribute="submit" variation={'primary'}>
                        {t('auth_modal.login')}
                    </Button>
                    {this.state.busy && <Spinner variations={['inline', 'login']} />}
                </div>
                <div className="modal-form__footer">
                    <div className="field__message">
                        <span> © 99designs </span>
                        <PrivacyLink /> <TermsLink />
                    </div>
                </div>
            </form>
        );
    }

    handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        const { onSuccess } = this.props;
        const { email, password } = this.state;
        const t = (id: string) => this.context.intl.formatMessage({ id });

        this.setState({ busy: true });

        e.preventDefault();
        try {
            await login(email, password);
        } catch (errors) {
            this.setState({
                errors: errors || { email: t('auth_modal.generic_error') },
            });
            return;
        } finally {
            this.setState({ busy: false });
        }
        onSuccess();
    };
}

export default AuthLoginForm;



// WEBPACK FOOTER //
// ./js/common/components/AuthLoginForm.tsx